angular.module('pims').filter('timeAgo', () => {
  return (input) => {
    let timeAgo = Math.abs(new Date() - new Date(input));
    if (timeAgo < 1000) {
      return {
        value: 1,
        unit: 'seconds',
      };
    }
    let i = 0;
    const timeDemarcations = [
      { unit: 'seconds', demarcation: 1000 },
      { unit: 'minutes', demarcation: 60 },
      { unit: 'hours', demarcation: 60 },
      { unit: 'days', demarcation: 24 },
      { unit: 'weeks', demarcation: 7 },
    ];
    while (
      i < timeDemarcations.length &&
      (timeAgo / timeDemarcations[i].demarcation) > 1
      ) {
      timeAgo /= timeDemarcations[i].demarcation;
      i += 1;
    }
    i -= 1;
    const isSingular = Math.floor(timeAgo) === 1;
    return `${Math.floor(timeAgo)} ${isSingular ? timeDemarcations[i].unit.slice(0, -1) : timeDemarcations[i].unit} ago`
  };
});
